// ActionCable subscriptions and the global signature hook.

// payload = what the signer confirmed before signing, when their signature had
// a brief (SignatureBrief) — e.g. the starting five a coach picked
global.onSignatureSigned = function(uuid, payload) {
  if(typeof context !== 'undefined' && context && typeof context.confirmSigned === 'function') {
    context.confirmSigned(uuid, payload);
  }
};

// The signer refused: they read the brief and pressed "Nekaj ni v redu".
// Only the prematch answers this — it is the page holding a roster the coach's
// confirmation locked. Every other page ignores it, as it does the signed event.
global.onSignatureCancelled = function(data) {
  if(typeof context !== 'undefined' && context && typeof context.signatureCancelled === 'function') {
    context.signatureCancelled(data || {});
  }
};

global.ws = {
  // Returns the subscription, so a caller can perform(...) an action on it —
  // follow_match.js asks the play-by-play channel to resync that way.
  subscribe: function(channel, params, onReceived) {
    var consumer = ActionCable.createConsumer();
    params = params || {};
    params.channel = channel;
    console.log(params);
    return consumer.subscriptions.create(params, {
      connected() {
        // Called when the subscription is ready for use on the server
        console.log(`${channel} connected`);
      },

      disconnected() {
        // Called when the subscription has been terminated by the server
        console.log(`${channel} disconnected`);
      },

      received(data) {
        if(onReceived) {
          onReceived(data);
        }
      }
    });
  }
};
